/**
 * External Dependencies
 */
import 'jquery';
import 'alpinejs';
//import AOS from 'aos';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faTwitter, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

// Import modules
import Swiper from './modules/swiper';
import Stats from './modules/stats';
import LoadMore from './modules/loadMore';

$(document).ready(() => {

  // Swipers.js
  Swiper.init();

  // Animated stats
  Stats.init();

  // LoadMore
  LoadMore.init();

  // Font awesome
  library.add(faFacebookF, faInstagram, faLinkedinIn, faTwitter);
  dom.watch();

});
